import {EventBus} from "../../../../../../common/ts/events/EventBus";
import {
    WhitelabelEvent
} from "../../../../../../common/ts/events/Events";
import {SaveWebPushAlertRequestedEvent, WPNPermissionsEvent} from "./events";
import AdFormService from "../../../../../../common/ts/services/AdFormService";
import {WebPushNotificationsStorage} from "../../../webpush-notifications/model/webPushNotificationsStorage";

let eventBus: EventBus;
const wpnStorage = new WebPushNotificationsStorage();

interface WpnSubscriptionResponseBody {
    pushUserId: string,
    isSuccessful: boolean,
    message: string,
}

export function saveWebPushNotificationRequestedEventHandler(event: WhitelabelEvent) {
    const { payload: { search, subscription } } = event as SaveWebPushAlertRequestedEvent;
    const adFormService = new AdFormService();
    const key = subscription.getKey("p256dh");
    const auth = subscription.getKey("auth");

    adFormService
        .wpnSubscriber(search, subscription, wpnStorage.getPushUserId(), getuqTrovitId())
        .then(response => {
            response.json().then((responseBody: WpnSubscriptionResponseBody) => {
                if (response.status === 201) {
                    if (wpnStorage.getPushUserId() === '' && responseBody.pushUserId) {
                        if (wpnStorage.getSearch(search.what) === undefined) {
                            wpnStorage.saveSearch(search.what);
                        }
                        wpnStorage.savePushUserId(responseBody.pushUserId);
                    }
                }
            })
        });
}

export function trackWPNPermissionsEventHandler(event: WhitelabelEvent) {
    const { payload: { pageData, userId, eventType } } = event as WPNPermissionsEvent;
    const adFormService = new AdFormService();
    adFormService.trackWPNPermissions(pageData, wpnStorage.getPushUserId(), getuqTrovitId(), eventType);
}

function init(ev: any = EventBus.getInstance()) {
    eventBus = ev;
    eventBus.subscribe(SaveWebPushAlertRequestedEvent.TYPE, saveWebPushNotificationRequestedEventHandler);
    eventBus.subscribe(WPNPermissionsEvent.TYPE, trackWPNPermissionsEventHandler);
}

function getCookie(ckey: string) {
    var value = '; ' + document.cookie + '; ';
    var parts = value.split('; ' + ckey + '=');
    // @ts-ignore
    var x: string = parts.pop().split(';').shift();
    x = decodeURIComponent(x);
    return x;
}

function getuqTrovitId(): string {
    let uqTrovit = getCookie('uqTrovit');

    return uqTrovit ? (JSON.parse(uqTrovit).id || '') : '';
}

export default {
    init,
};
